import { useCallback, useEffect, useRef, useState } from "react";
import { ContactCentreProps } from "./contact-centre.props";
import Banner from "src/components/molecules/banner/Banner";
import ContactCentreAddNew from "../contact-centre-add-new/contact-centre-add-new";
import ContactCentreList from "../contact-centre-list/contact-centre-list";
import { IContactCentreModel } from "src/types/models/apiModels";
import { ContactCentreListViewModel } from "../contact-centre-list/contact-centre-list.view-model";
import { useAuth } from "../auth/auth-context";

const ContactCentre: React.FC<ContactCentreProps> = ({ openInEditMode }) => {
	const [title, setTitle] = useState("Contact Centres");
	const [editMode, setEditMode] = useState<boolean>(openInEditMode ?? false);
	const [contactCentre, setContactCentre] = useState<
		IContactCentreModel | undefined
	>(undefined);
	const viewModel = useRef<ContactCentreListViewModel | null>(null);
	const { user } = useAuth(); // Extract user from useAuth hook

	const handleSave = useCallback((contactCentre: IContactCentreModel) => {
		console.log("submitContactCentreCallBack!", contactCentre);
		toggleEditMode();
	}, []);

	const handleOnCancel = useCallback(() => {
		toggleEditMode();
	}, []);

	const handleOnAdd = useCallback(() => {
		toggleEditMode();
	}, []);

	const toggleEditMode = () => {
		setEditMode((prevValue) => !prevValue);
	};

	const handleOnSelected = useCallback(
		(contactCentre: IContactCentreModel) => {
			setContactCentre(contactCentre);
			toggleEditMode();
		},
		[]
	);

	const handleOnDeleted = async (contactCentre: IContactCentreModel) => {
		await viewModel.current?.deleteContactCentre(
			contactCentre.contactCentreId
		);
	};

	useEffect(() => {
		if (user && user.accessToken) {
			viewModel.current = new ContactCentreListViewModel(
				user.accessToken
			);
		}
	}, []);

	useEffect(() => {
		if (editMode) {
			setTitle("Add / Edit Contact centre");
		} else {
			setTitle("Contact centres");
			setContactCentre(undefined);
		}
	}, [editMode]);

	// Functions to handle opening and closing the dialog

	return (
		<Banner label={title}>
			<div className="drop-shadow-2xl">
				{editMode === false ? (
					<div className="bg-white p-6 w-full overflow-auto rounded-lg drop-shadow-2xl">
						<ContactCentreList
							onSelectClicked={(contactCentre) =>
								handleOnSelected(contactCentre)
							}
							onAddNewClick={handleOnAdd}
							onDeleteClicked={(contactCentre) =>
								handleOnDeleted(contactCentre)
							}
						></ContactCentreList>
					</div>
				) : (
					<ContactCentreAddNew
						contactCentreInput={contactCentre}
						onSave={handleSave}
						onCancel={handleOnCancel}
					></ContactCentreAddNew>
				)}
			</div>
		</Banner>
	);
};

export default ContactCentre;
